export default __webpack_public_path__ + "static/cooldoggo-0504ad172942086fb4b4b0ecb0761e8b.png";